/* eslint-disable no-restricted-syntax */
/* eslint-disable no-useless-escape */

// validate email
const validateEmail = (email) => {
	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
};

// const validateConfirmEmail = (emailEl) => {
// 	const equalToName = emailEl.getAttribute('data-equal-name');
// 	const confirmEmailEl = document.querySelector(`input[name="${equalToName}"]`);
// 	if (emailEl.value === confirmEmailEl.value) {
// 		validate.removeError(confirmEmailEl);
// 	}
// 	return emailEl.value === confirmEmailEl.value;
// };

// validate tel
const validatePhoneUK = (phoneNumber) => {
	return phoneNumber.length > 9 && phoneNumber.match(/^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/);
};

// validate date of birth
// const validateBirth = (DOBFormElement) => {
// 	const date = DOBFormElement.value;
// 	const maxDate =
// 		DOBFormElement.getAttribute('data-max-date') === 'today'
// 			? new Date()
// 			: new Date(DOBFormElement.getAttribute('data-max-date'));
// 	const dateSplit = date.split('/');
// 	const DOB = new Date(
// 		`${dateSplit[1]}/${dateSplit[0]}/${dateSplit[2]}`
// 	).getTime();
// 	const currDate = maxDate ? maxDate.getTime() : new Date().getTime();
// 	return currDate > DOB;
// };

// validate postcode uk
const validatePostcode = (postcode) => {
	const re = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;
	return re.test(postcode);
};

/**
 * Select element validation
 * @param selectFormElement
 * @returns {boolean}
 */
const formCheckSelect = (selectFormElement) => {
	let error = false;
	const { value } = selectFormElement;

	// Note: show/hide the detail input for selects that have .need-additional-detail
	const hasAdditionalDetail = selectFormElement.classList.contains('need-additional-detail');
	if (hasAdditionalDetail) {
		const needDetailOptions = selectFormElement.querySelectorAll('.trigger-additional-detail');
		const parentFromField = selectFormElement.closest('.form-field');
		const nextAdditionalDetail = parentFromField.nextSibling.nextElementSibling;

		const needDetailOptionValues = [];
		for (const option of needDetailOptions) {
			needDetailOptionValues.push(option.innerText);
		}

		if (needDetailOptionValues.includes(value)) {
			nextAdditionalDetail.classList.add('show');
			nextAdditionalDetail.setAttribute('aria-hidden', 'false');
		} else {
			nextAdditionalDetail.classList.remove('show');
			nextAdditionalDetail.setAttribute('aria-hidden', 'true');
		}
	}

	if (value !== '' && parseInt(value, 10) !== -1) {
		error = true;
	}
	return error;
};

/**
 * Radio elements validation
 * @param selectFormElement
 * @returns {boolean}
 */
const formCheckRadio = (radioFormElement) => {
	const radioName = radioFormElement.getAttribute('name');
	const radioOptions = document.querySelectorAll(`[name="${radioName}"]`);

	// Note: show/hide the detail input for radios that have .need-additional-detail
	const hasAdditionalDetail = radioFormElement.parentElement.parentElement.classList.contains('need-additional-detail');
	if (hasAdditionalDetail) {
		const optionValue = radioFormElement.value;
		const parentFromField = radioFormElement.closest('.form-field');
		const nextAdditionalDetail = parentFromField.nextSibling.nextElementSibling;

		if (optionValue === 'yes') {
			nextAdditionalDetail.classList.add('show');
			nextAdditionalDetail.setAttribute('aria-hidden', 'false');
		} else {
			nextAdditionalDetail.classList.remove('show');
			nextAdditionalDetail.setAttribute('aria-hidden', 'true');
		}
	}

	// loop all radio items with this name
	let error = false;
	for (const radioOption of radioOptions) {
		if (radioOption.checked === true) {
			error = true;
		}
	}
	return error;
};

/**
 * Checkbox elements validation
 * @param selectFormElement
 * @returns {boolean}
 */
const formCheckbox = (checkboxFormElement) => {
	let error = false;
	const checkboxGroup = checkboxFormElement.parentElement.parentElement;

	// check if the checkboxFormElement is in the .checkbox-group
	if (checkboxGroup.getAttribute('type') === 'checkbox-group') {
		const checkboxOptions = checkboxGroup.querySelectorAll('input[type="checkbox"]');

		// loop all checkbox items
		for (const checkboxOption of checkboxOptions) {
			if (checkboxOption.checked === true) {
				error = true;
			}
		}
	} else if (checkboxFormElement.checked === true) {
		error = true;
	}

	return error;
};

/**
 * Checkbox Group elements validation
 * @param checkboxGroupElement
 * @returns {boolean}
 */
const formCheckboxGroup = (checkboxGroupElement) => {
	let error = false;
	const checkboxOptions = checkboxGroupElement.querySelectorAll('input[type="checkbox"]');

	// loop all checkbox items
	for (const checkboxOption of checkboxOptions) {
		if (checkboxOption.checked === true) {
			error = true;
		}
	}

	return error;
};

/**
 * Checkbox Group elements validation
 * @param selectGroupElement
 * @returns {boolean}
 */
const formSelectGroup = (selectGroupElement) => {
	let error = true;

	const selects = selectGroupElement.querySelectorAll('select');

	// Note: loop all select items
	for (const select of selects) {
		const defaultLabel = select.querySelectorAll('option')[0].innerText;
		const currentOption = select.parentElement.querySelector('.niceselect-text').innerText;

		if (currentOption === defaultLabel) {
			error = false;
			return;
		}
	}

	return error;
};

/**
 * Dropdown elements validation
 * @param dropdownElement
 * @returns {boolean}
 */
const formDropdown = (dropdownElement) => {
	let error = false;

	if (dropdownElement.classList.contains('selected')) {
		error = true;
	}

	return error;
};

const validate = {
	settings: {
		valueMissingradio: 'Please select an option.',
		valueMissingselect: 'Please select an option.',
		valueMissingcheckbox: 'Please check this box to proceed.',
		valueMissingTextarea: 'Please enter some contents for this field.',
		valueMissingCheckboxGroup: 'Please select an option.',
		email: 'Please enter a valid email address.',
		confirmEmail: 'Please ensure emails match.',
		generic: 'This field is required.',
		tel: 'Please specify a valid phone number e.g. 01491 825522.',
		postcode: 'Please specify a valid postcode.',
		date: 'Please type in valid date.',
		messageTooShort: 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.',
		messageTooLong: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
		messageRangeOverflow: 'Please select a value that is no more than {max}.',
		messageRangeUnderflow: 'Please select a value that is no less than {min}.',
		messagePatternMismatch: 'Please match the requested format.',
		beforeShowError: () => {},
		afterShowError: () => {},
		beforeRemoveError: () => {},
		afterRemoveError: () => {},
	},
	addErrorMsg: (field, errorMsg) => {
		field.setAttribute('aria-invalid', 'true');
		const parentElement = field.closest('.freeform-column');
		const fieldErrorMsgElement = document.createElement('ul');
		fieldErrorMsgElement.classList.add('errors', 'freeform-errors');
		fieldErrorMsgElement.setAttribute('aria-hidden', 'false');
		fieldErrorMsgElement.setAttribute('aria-live', 'assertive');
		fieldErrorMsgElement.setAttribute('aria-relevant', 'additions removals');

		if (!parentElement.lastElementChild.classList.contains('freeform-errors')) {
			const fieldErrorMessage = document.createElement('li');
			fieldErrorMessage.innerText = errorMsg;
			fieldErrorMsgElement.appendChild(fieldErrorMessage);
			parentElement.appendChild(fieldErrorMsgElement);
		}

		parentElement.classList.add('error');
	},
	removeErrorMsg: (field) => {
		field.setAttribute('aria-invalid', 'false');
		const parentElement = field.closest('.freeform-column');

		if (parentElement.classList.contains('error')) {
			parentElement.classList.remove('error');
			const errorEl = parentElement.querySelector('.freeform-errors');
			parentElement.removeChild(errorEl);
		}
	},
	hasError: (field) => {
		const localSettings = validate.settings;

		if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') return;

		const { validity } = field;

		if (field.type === 'select-one') {
			return !formCheckSelect(field) ? localSettings.valueMissingselect : '';
		}
		if (field.type === 'email') {
			return !validateEmail(field.value) ? localSettings.email : '';
		}
		if (field.type === 'tel') {
			return !validatePhoneUK(field.value) ? localSettings.tel : '';
		}
		if (field.type === 'radio') {
			return !formCheckRadio(field) ? localSettings.valueMissingradio : '';
		}
		if (field.getAttribute('type') === 'checkbox-group') {
			return !formCheckboxGroup(field) ? localSettings.valueMissingCheckboxGroup : '';
		}
		if (field.getAttribute('type') === 'select-group') {
			return !formSelectGroup(field) ? localSettings.valueMissingSelectGroup : '';
		}
		if (field.getAttribute('type') === 'dropdown') {
			return !formDropdown(field) ? localSettings.valueMissingCheckboxGroup : '';
		}
		if (field.getAttribute('input-data-type') === 'postcode') {
			return !validatePostcode(field.value) ? localSettings.postcode : '';
		}

		if (validity.valid) return;

		if (validity.valueMissing) {
			switch (field.type) {
				case 'select-one':
					return !formCheckSelect(field) ? localSettings.valueMissingselect : '';

				case 'radio':
					return !formCheckRadio(field) ? localSettings.valueMissingradio : '';

				case 'checkbox-group':
					return !formCheckboxGroup(field) ? localSettings.valueMissingCheckboxGroup : '';

				case 'checkbox':
					return !formCheckbox(field) ? localSettings.valueMissingcheckbox : '';

				case 'textarea':
					return localSettings.valueMissingTextarea;

				default:
					return localSettings.generic;
			}
		}

		if (validity.typeMismatch) {
			if (field.type === 'email' && !validateEmail(field.value)) return localSettings.email;
			if (field.type === 'tel' && !validatePhoneUK(field.value)) return localSettings.tel;
		}

		if (validity.tooShort) {
			return localSettings.messageTooShort.replace('{minLength}', field.getAttribute('minLength')).replace('{length}', field.value.length);
		}

		if (validity.tooLong) {
			return localSettings.messageTooLong.replace('{minLength}', field.getAttribute('maxLength')).replace('{length}', field.value.length);
		}

		if (validity.rangeOverflow) {
			return localSettings.messageRangeOverflow.replace('{max}', field.getAttribute('max'));
		}

		if (validity.rangeUnderflow) {
			return localSettings.messageRangeUnderflow.replace('{min}', field.getAttribute('min'));
		}

		if (validity.patternMismatch) {
			return localSettings.messagePatternMismatch;
		}

		return localSettings.generic;
	},
	removeError: (field) => {
		const localSettings = validate.settings;

		localSettings.beforeRemoveError(field);
		validate.removeErrorMsg(field);
		localSettings.afterRemoveError(field);
	},
	showError: (field, error) => {
		const localSettings = validate.settings;

		localSettings.beforeShowError(field, error);
		const errorMsgEl = field.parentNode.querySelectorAll('.error-message');
		if (!errorMsgEl.length) {
			validate.addErrorMsg(field, error);
		} else {
			errorMsgEl[0].querySelector('p').innerText = error;
		}
		localSettings.afterShowError(field, error);
	},
	inputHandler(event) {
		let error = '';
		if (!event.target.form && !event.target.classList.contains('dropdown-item')) return;

		// for checkbox group
		if (event.target.parentElement.parentElement.getAttribute('type') === 'checkbox-group') {
			error = validate.hasError(event.target.parentElement.parentElement);
			// for dropdown checkbox
		} else if (event.target.closest('.dropdown') && event.target.closest('.dropdown').getAttribute('type') === 'dropdown') {
			error = validate.hasError(event.target.closest('.dropdown'));
		} else if (event.target.parentElement.parentElement.getAttribute('type') === 'select-group') {
			error = validate.hasError(event.target.parentElement.parentElement);
		} else {
			// for rest of
			error = validate.hasError(event.target);
		}

		if (error) {
			validate.showError(event.target, error);
			return;
		}
		validate.removeError(event.target);
	},
};

export default validate;
